// @flow
import {combineReducers} from 'redux';
import {yesNoBlockReducer} from './yes-no-block';
import type {TYesNoBlockState} from './yes-no-block';

const reducers = {
    yesNoBlock: yesNoBlockReducer,
};

type TYesNoBlockModuleState = {
    yesNoBlock: TYesNoBlockState,
};

const yesNoBlockModuleReducer = combineReducers(reducers);
export {yesNoBlockModuleReducer};
export type {TYesNoBlockModuleState};
